export default __webpack_public_path__ + "static/media/default.9c9bdda411a291272065735e7719a36d.png";